import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { ModalVideoTags } from 'lib/components/modal/ModalVideoTags';
import { useState } from 'react';
import { Tag } from 'react-covideo-common';
import { useHistory } from 'react-router';
import { useAuth } from 'lib/context';
import {
  productFeature,
  checkIfFeatureIsEnabled,
} from 'lib/utils/productFeature';
import { Button } from 'react-covideo-common';
import { MdDeleteForever } from 'react-icons/md';
import { FaHashtag } from 'react-icons/fa';

type ComponentProps = {
  videoTags: any[];
  onUpdate: Function;
  id: string;
};

const Content = styled.div`
  width: 100px;
  margin: 16px 0;
  ${theme.mediaQueryMinWidth.xs} {
    width: 248px;
  }
  ${theme.mediaQueryMinWidth.lg} {
    width: 380px;
  }
`;

const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  align-content: flex-start;
  gap: 8px;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;
  .icon-wrapper {
    width: auto;
  }
`;

export const VideoTagsForRecordingReview = ({
  videoTags,
  onUpdate,
}: ComponentProps) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const onSave = (values: object[]) => {
    onUpdate(values);
    closeModal();
  };

  const history = useHistory();

  const { userData } = useAuth();

  const [isTagFeatureAvailable, setIsTagFeatureAvailable] =
    React.useState(true);

  React.useEffect(() => {
    const isTagEnabled = checkIfFeatureIsEnabled(
      userData,
      productFeature.VIDEO_TAGS
    );
    setIsTagFeatureAvailable(isTagEnabled);
  }, []);

  return (
    <Content>
      <ActionButtonContainer>
        <Button
          variant='destructive'
          icon={<MdDeleteForever size={24} />}
          text={'Remove this video'}
          onClick={() => {
            history.push('/record/home');
          }}
        />
        {isTagFeatureAvailable && (
          <Button
            variant='secondary'
            icon={<FaHashtag size={'16px'} />}
            text={'Add Tags...'}
            onClick={openModal}
          />
        )}
      </ActionButtonContainer>
      {!!videoTags.length && (
        <TagsContainer>
          {videoTags.map(tag => (
            <Tag key={tag.value} tag={tag} />
          ))}
        </TagsContainer>
      )}
      {showModal && (
        <ModalVideoTags
          videoTags={videoTags}
          handleModalClose={closeModal}
          onSubmit={onSave}
          title={'Manage Tags'}
          buttonTitle={'Save Changes'}
        />
      )}
    </Content>
  );
};
